module.exports = __webpack_public_path__ + "static/media/eye-green.2aea1116.svg";